// extracted by mini-css-extract-plugin
export default {"wrap":"XXoBTquWAn5hPngR9Jzo","loadingWrapper":"m9RRHOpas4gByWIRDbG6","forwardMessageButton":"Mfg0xngMg5cIZsKo2OBE"};